import { Modal } from "react-bootstrap";
import { Button } from "./Controls/Button";
import {
  InfoCircle,
  QrCode,
  ClipboardCheck,
  TicketPerforatedFill,
} from "react-bootstrap-icons";

type Props = {
  show: boolean;
  onHide: () => void;
};

export function ValidationsInfoModal({ show, onHide }: Props) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <InfoCircle className="text-primary" />
          About Validations
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-2">
        <div className="d-flex flex-column gap-4">
          <div className="bg-primary-subtle rounded p-3">
           
            <p className="mb-0 text-muted small">
              Choose how parkers receive the benefit of validated pricing — via a link, QR code, approval request, or checkout code.
            </p>
          </div>

          <div className="d-flex flex-column gap-3">
            <ValidationScenario
              icon={<QrCode className="text-warning" />}
              title="Discount Validation"
              description="Share a link or QR code that sends parkers to a page where their parking rate is discounted by the amount you configure."
              highlight="warning"
            />

            <ValidationScenario
              icon={<ClipboardCheck className="text-success" />}
              title="Fixed Validation"
              description="Share a link that takes parkers to a request form. Their request appears in Transient → Requests for your approval before the rate applies."
              highlight="success"
            />

            <ValidationScenario
              icon={<TicketPerforatedFill className="text-info" />}
              title="Code Validation"
              description="Create a unique code parkers enter during hourly checkout. Applies a flat or percent discount, or a set price that overrides the calculated rate. If nothing is owed, the reservation completes with no payment."
              highlight="info"
            />
          </div>

          <div className="bg-light rounded p-3 mt-2">
            <div className="fw-semibold mb-1">Quick Summary</div>
            <ul className="mb-0 small text-muted ps-3">
              <li>Discount & Fixed: distributed via link or QR code</li>
              <li>Code: entered at hourly checkout — no QR needed</li>
              <li>All types: set active dates, times, and discount rules like other rates</li>
            </ul>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button className="btn-main" onClick={onHide}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

type ValidationScenarioProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  highlight: "warning" | "success" | "info";
};

function ValidationScenario({
  icon,
  title,
  description,
  highlight,
}: ValidationScenarioProps) {
  const borderClass = `border-start border-${highlight} border-3`;

  return (
    <div className={`${borderClass} ps-3 py-1`}>
      <div className="d-flex align-items-center gap-2 mb-1">
        {icon}
        <span className="fw-semibold">{title}</span>
      </div>
      <p className="mb-0 small text-muted">{description}</p>
    </div>
  );
}
